import React, { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../../src/assets/img/icon/Right.svg';
import WhatsappDialog from '../../../../components/CommonDialogs/WhatsappDialog.component';
import StepperSubHeader from '../../../../components/Header/StepperSubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SuraCard from '../../../../components/SuraCard';
import VehicleCards from '../../../../components/VehicleCards/VehicleCards.component';
import VehicleList from '../../../../components/VehicleList/VehicleList.component';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSidebarContext } from '../../../../context/sidebar/sidebar.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import {
  POLICIES_QUERY,
  POLICIES_QUERY_CONFIG,
  policiesQuery,
} from '../../../../query/policies/policies';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../../query/vehicles/vehicles';
import { myProducts } from '../../../../services/products/products.service';
import ProductsSelectionCards from './Subcomponents/ProductsSelectionCards.component';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: `calc(100% - ${theme.spacing(2)}px)`,
      '& a': {
        height: '100%',
      },
    },
  })
);

const InitCancel = () => {
  const [productsList, setProductsList] = useState([]);
  const [userHasCar, setUserHasCar] = useState(false);
  const [productsF, setProductsF] = useState<any[]>([]);
  const [listProducts, setListProducts] = useState(false);
  const [hasMoreProducts, setHasMoreProducts] = useState(false);
  const classes = useStyle();
  const [, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { setStepperTitle } = useSidebarContext();
  const { user } = useAuthDataContext();

  const { data: vehicles } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );

  const { data: policies } = useQuery(
    [POLICIES_QUERY, { name: 'product_codes', value: productsF.join(',') }],
    policiesQuery,
    POLICIES_QUERY_CONFIG
  );

  useEffect(() => {
    setStepperTitle('Cancelar póliza');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  useEffect(() => {
    getMyProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMyProducts = async () => {
    setLoading(true);
    await myProducts().then((productsDataList) => {
      setProductsList(productsDataList.data);
      setLoading(false);
      let hasCar = !!productsDataList.data.find(
        (element: any) => element.code === 4
      );

      setUserHasCar(hasCar);
    });
  };

  useEffect(() => {
    if (productsList.length > 1) {
      setListProducts(true);
    }
    setLoading(false);
  }, [productsList.length]);

  const filterProduct = useCallback((productsFilter) => {
    setProductsF(productsFilter);
  }, []);

  const finishSelection = useCallback(
    (selectedProducts) => {
      dataLayerPush('cuenta_cancelar_poliza_productos', user?.id, {
        fieldName: 'params',
        fieldValue: selectedProducts,
      });
      setListProducts(false);
      dataLayerPush('cuenta_cancelar_poliza_consulta', user?.id);

      const clientHasCar = productsF.includes(4);

      if (clientHasCar === true && productsF.length === 1) {
        setHasMoreProducts(false);
      } else {
        setHasMoreProducts(true);
      }
    },
    [productsF, user]
  );

  const [openDialog, setOpenWhatsappDialog] = useState(false);
  const validateCompany = (company, policy_id, pledge) => {
    company.toLowerCase() == 'galicia'
      ? setOpenWhatsappDialog(true)
      : validatePlege(pledge, policy_id);
  };

  const validatePlege = (pledge, policy_id) => {
    pledge
      ? setOpen(true)
      : history.push(`/cancel-policy/vehicle/${policy_id}`);
  };

  return (
    <>
      <WhatsappDialog
        is_open={openDialog}
        close_dialog={() => setOpenWhatsappDialog(false)}
        message={`En este momento no podemos mostrarte la información de tu póliza.
        Podés seguir operando vía Whatsapp.`}
      />

      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>
      <StepperSubHeader
        goBack={() =>
          (userHasCar && productsList.length === 1) || listProducts === true
            ? history.goBack()
            : setListProducts(true)
        }
      ></StepperSubHeader>
      {listProducts ? (
        <>
          <ProductsSelectionCards
            cards={productsList}
            filterProduct={filterProduct}
            finishSelection={finishSelection}
          ></ProductsSelectionCards>
        </>
      ) : hasMoreProducts ? (
        <>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={11}>
              <Grid container>
                <Grid item xs={12}>
                  <Box my={4}>
                    <Typography variant="h6">
                      ¿Qué póliza querés consultar?
                    </Typography>
                  </Box>
                </Grid>
                {policies?.length
                  ? policies.map((policy: any, index: number) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Box mx={1} my={1} className={classes.card}>
                          <ButtonBase
                            // {...(!policy.pledge && {
                            // component: RouterLink,
                            // to: '/cancel-policy/vehicle/' + policy.id,
                            // })}
                            // {...(policy.pledge && {
                            // onClick: () => setOpen(true),
                            // })}
                            onClick={() =>
                              validateCompany(
                                policy.provider.company,
                                policy.id,
                                policy.pledge
                              )
                            }
                            style={{ width: '100%' }}
                          >
                            <SuraCard>
                              <Box
                                m={2}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width="100%"
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="flex-start"
                                  flexDirection="column"
                                >
                                  <Box>
                                    <Typography display="inline">
                                      Póliza {policy.number}
                                      {/* -{" "}
                                      {CoverageStatus[policy.status]} */}
                                    </Typography>
                                    <Box mt={1}>
                                      <Typography
                                        color="secondary"
                                        variant="subtitle2"
                                      >
                                        {policy.vehicles.length > 10 ? (
                                          <Accordion defaultExpanded square>
                                            <AccordionSummary
                                              // expandIcon={<ExpandMoreIcon />}
                                              aria-controls="panel1a-content"
                                              id="panel1a-header"
                                            >
                                              FLOTA
                                            </AccordionSummary>
                                            <AccordionDetails>
                                              <Typography
                                                color="secondary"
                                                variant="subtitle2"
                                              >
                                                {policy.vehicles?.map(
                                                  (
                                                    vehicle: any,
                                                    index: number
                                                  ) =>
                                                    vehicle.license_plate +
                                                      ' ' || ''
                                                )}
                                              </Typography>
                                            </AccordionDetails>
                                          </Accordion>
                                        ) : !policy.vehicles.length ? (
                                          policy.product.description
                                        ) : (
                                          <div>
                                            Patente:{' '}
                                            {policy.vehicles[0]?.license_plate}
                                          </div>
                                        )}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                                <Box>
                                  {policy.vehicles.length < 10 && (
                                    <RightIcon></RightIcon>
                                  )}
                                </Box>
                              </Box>
                            </SuraCard>
                          </ButtonBase>
                        </Box>
                      </Grid>
                    ))
                  : 'No tenés pólizas para los ramos seleccionados'}
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={10}>
              <Grid item xs={11}>
                <Box mt={5}>
                  <Typography variant="h6">
                    ¿Qué póliza querés consultar?
                  </Typography>
                </Box>
              </Grid>

              {vehicles && vehicles.length > 10 ? (
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={11}>
                    <VehicleList
                      baseUrl={'/cancel-policy/vehicle/'}
                      withPolicy
                    ></VehicleList>
                  </Grid>
                </Grid>
              ) : (
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={11}>
                    <VehicleCards
                      baseUrl={'/cancel-policy/vehicle/'}
                      withPolicy
                    ></VehicleCards>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default InitCancel;
